import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { UseraccessserviceService } from '../useraccessservice.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import {catchError, tap} from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { OfflineConnectivityService } from '../offline/offline-connectivity.service';
import { isNetworkFailure } from '../offline/offline-network-failure';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorService  implements HttpInterceptor{

  // Injector, not a constructor param — keeps OfflineConnectivityService's own dependency graph
  // (which pulls in OfflineEntitlementService/OfflineSaveService lazily via Injector.get() for
  // the same reason) out of this interceptor's construction, resolved only when a request
  // actually needs it.
  constructor( private useraccessservice : UseraccessserviceService, private toastr : ToastrService, private injector: Injector) { }

    intercept(request : HttpRequest<any>,next:HttpHandler) : Observable<HttpEvent<any>>{
      const currentUserToken = this.useraccessservice.getCurrentUserToken();
      const isLoggedIn = currentUserToken != null;

      if(isLoggedIn && request.url.startsWith(environment.ImpataAppAPIRoot)){
        request = request.clone({
            setHeaders : {
                Authorization : `Bearer ${currentUserToken}`
            }
          });
      }

      // Free connectivity signal from real app traffic, scoped to this app's own API so a
      // failing third-party request (reCAPTCHA, Stripe.js, media CDN) never affects it —
      // formerly OfflineCacheInterceptor's job; that interceptor is gone (offline mode no
      // longer tries to serve arbitrary pages from cache), but OfflineConnectivityService
      // still needs to know when the network is actually down.
      if (request.url.startsWith(environment.ImpataAppAPIRoot)) {
        return next.handle(request).pipe(
          tap((event) => {
            if (event instanceof HttpResponse) this.injector.get(OfflineConnectivityService).reportSuccess();
          }),
          catchError((error) => {
            if (isNetworkFailure(error)) {
              this.injector.get(OfflineConnectivityService).reportFailure();
            }
            return throwError(() => error);
          }),
        );
      }
      return next.handle(request);

    }

    // handleError(error:HttpErrorResponse){
    //   this.toastr.error("Boom", "Connection Error", { timeOut : 5000 });      
    //   if(error.status === 0){
    //     this.toastr.error("Unable to connect to server", "Connection Error", { timeOut : 5000 });      
    //   }
    //   else if(error.status === 400){        
    //     this.toastr.error(error.error.message, "Error", { timeOut : 5000 });
    //   }
    //   else{
    //     this.toastr.error(error.statusText, "Error", { timeOut : 5000 });
    //   }
    //   return throwError(error);
    // }

}
